import type { FooterType } from './footer.d';
import type { MenuItens } from './menu-itens.d';

/**
 * Global Configuration Types
 */
type Link = {
  rel: string;
  type?: string;
  href: string;
};

export type Seo = {
  title: string;
  meta: {
    description: string;
    'theme-color': string;
  };
  links: Link[];
};

export const enum BUSINESS_UNITS {
  DEFAULT = 'eud',
  BOT = 'bot',
  EUD = 'eud',
  VDI = 'vdi',
}

interface DomainConfig<T = string> {
  app: {
    staticUrl?: string;
    basename?: string;
    name: T;
    short: T;
    fallbackUrl: string;
    logout: string;
    slugname: string;
  };

  acceptedCards: string[];
  bff: {
    applicationID: T;
    baseUrl: T;
    clientID: T;
    getCustomHeaders?: () => Record<string, string | null>;
  };
  configCat: {
    sdkKey: string;
  };
  cashbackLabel: string;
  cashbackToolTip: boolean;
  communication: {
    userNamingConvention: {
      singular: string;
      plural: string;
    };
    sac: {
      openingHours: {
        week: {
          days: string;
          hours: string;
        };
        weekend: {
          days: string;
          hours: string;
        };
      };
      phone: string;
      whatsapp: string;
      whatsappText: string;
    };
    page401: {
      subtitle: string;
    };
  };
  isAdministrateTax: boolean;
  google: {
    gtm: {
      containerID: T;
    };
    analytics: {
      id: T;
    };
    recaptcha: {
      secretKey: T;
    };
  };
  pickupStore: number;
  reseller: number;
  retroActiveReseller: number;
  newRelic: {
    accountID: T;
    agentID: T;
    licenseKey: T;
    trustKey: T;
  };
  oneTrustCookie: {
    key: string;
  };
  prismic: {
    accessToken: T;
    apiUrl: T;
    repo: T;
  };
  seo: Seo;
  footer: FooterType;
  header: {
    fixed: boolean;
  };
  renegotiationSac: {
    whatsapp: string;
    phone: string;
    portalName: string;
    portalLink: string;
    hours: {
      whatsapp: string;
      phone: string;
      portal: string;
    };
  };
  signup: {
    site: string;
  };
  navBar: MenuItens;
}

export interface SharedConfig<T = string> {
  app: {
    environment?: T;
    mediaRatio: number;
    url: T;
    version: string;
  };
  formCreditCard: {
    baseUrl: T;
  };
}

export type Config = DomainConfig & SharedConfig;
